import React, { ReactNode, useMemo } from 'react'
import {
  inspectorHoveredElementContext,
  inspectorContext,
  useInspectorOverlayEvents,
  InspectorContext,
  useHasAnyLayerWithExportableAssets,
} from '../../hooks/inspector'
import { useGetActiveSidebarTab } from 'modules/shares/components/ShareSidebarTabContext'
import { useSketchSceneTree } from '../../hooks/inspector/useSketchSceneTree'

type ArtboardDetailInspectorProviderProps = {
  children: ReactNode
}

export function ArtboardDetailInspectorProvider({
  children,
}: ArtboardDetailInspectorProviderProps) {
  const activeSidebarTab = useGetActiveSidebarTab()
  const isInspectorActive = activeSidebarTab === 'Inspect'

  const sketchSceneRootElement = useSketchSceneTree()
  const hasAnyLayerWithExportableAssets = useHasAnyLayerWithExportableAssets(
    sketchSceneRootElement
  )

  const {
    selectedElement,
    hoveredElement,
    setSelectedElement,
    clickHandler,
    mouseMoveHandler,
  } = useInspectorOverlayEvents(
    sketchSceneRootElement,
    // Handle web renderer events only when we need to
    isInspectorActive
  )

  const inspectorContextValue = useMemo((): InspectorContext => {
    return {
      selectedElement: selectedElement,
      isInspectorActive: isInspectorActive,
      sketchSceneRootElement: sketchSceneRootElement,
      setSelectedElement: setSelectedElement,
      isInspectorReady: Boolean(sketchSceneRootElement),
      hasAnyLayerWithExportableAssets,
      clickHandler,
      mouseMoveHandler,
    }
  }, [
    clickHandler,
    hasAnyLayerWithExportableAssets,
    sketchSceneRootElement,
    isInspectorActive,
    mouseMoveHandler,
    selectedElement,
    setSelectedElement,
  ])

  return (
    <inspectorContext.Provider value={inspectorContextValue}>
      <inspectorHoveredElementContext.Provider value={hoveredElement}>
        {children}
      </inspectorHoveredElementContext.Provider>
    </inspectorContext.Provider>
  )
}
